// Get Network Order Detail
export const GET_NETWORK_ORDER_DETAIL_REQUEST = 'GET_NETWORK_ORDER_DETAIL_REQUEST';
export const GET_NETWORK_ORDER_DETAIL_DONE = 'GET_NETWORK_ORDER_DETAIL_DONE';
export const GET_NETWORK_ORDER_DETAIL_FAILED = 'GET_NETWORK_ORDER_DETAIL_FAILED';
export const GET_NETWORK_ORDER_DETAIL_RESET = 'GET_NETWORK_ORDER_DETAIL_RESET';

// Cancel Network Order
export const CANCEL_NETWORK_ORDER_REQUEST = 'CANCEL_NETWORK_ORDER_REQUEST';
export const CANCEL_NETWORK_ORDER_DONE = 'CANCEL_NETWORK_ORDER_DONE';
export const CANCEL_NETWORK_ORDER_FAILED = 'CANCEL_NETWORK_ORDER_FAILED';
